// React
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

// Imagenes
import { BackgroundMain as BackgroudImage, LogoSplashDark } from "../../config/brandAssets";

import { useUserStore } from "../../store/userStore";
import { isTokenExpired, decodeJWT } from "../../utils/tokenUtils";
import { resolveLandingRoute } from "../../config/appsConfig";

const apiUrl = import.meta.env.VITE_FIREBASE_API_URL;

export default function SplashScreen() {
  const setUser = useUserStore((s) => s.setUser);
  const navigate = useNavigate();
  const location = useLocation();
  const handledRef = useRef(false);

  useEffect(() => {
    // Solo se resuelve el destino una vez por montaje: evita que una segunda
    // pasada (re-render / cambio de pathname) consuma un lastRoute ya borrado
    // y rebote a /map.
    if (handledRef.current) return;
    handledRef.current = true;

    const token = localStorage.getItem("token");
    const goTo = (path: string) => {
      if (location.pathname !== path) {
        navigate(path);
      }
    };

    const goToLogin = () => {
      setUser(null);
      localStorage.removeItem("token");
      localStorage.removeItem("sessionId");
      goTo("/");
    };

    if (token && !isTokenExpired(token)) {
      // Decodificar el token para obtener el email
      const decoded = decodeJWT(token);
      const email = decoded?.email;

      if (email) {
        fetch(
          `${apiUrl}/user?email=${encodeURIComponent(email)}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          }
        )
          .then(async (res) => {
            const data = await res.json();
            if (data && (data.user || data.data)) {
              setUser(data.user || data.data);
              const lastRoute = localStorage.getItem("lastRoute");
              if (lastRoute && lastRoute !== "/") {
                localStorage.removeItem("lastRoute");
                goTo(lastRoute);
              } else {
                // Sin ruta previa: pantalla de inicio configurada (defaultLanding)
                // o el grid de apps (/apps). Solo web_services (sin acceso al
                // grid) va directo a /admin.
                const userRole = localStorage.getItem("userRole");
                if (userRole === "web_services") {
                  goTo("/admin/units");
                } else {
                  goTo(resolveLandingRoute());
                }
              }
            } else {
              goToLogin();
            }
          })
          .catch(() => {
            goToLogin();
          });
      } else {
        // Token no tiene email, limpiar y ir al login
        goToLogin();
      }
    } else {
      // No hay token o está expirado
      goToLogin();
    }
  }, [location.pathname, navigate, setUser]);

  return (
    <div className="w-full h-screen flex flex-col relative">
      <img
        src={BackgroudImage}
        alt="Img not found"
        className="absolute w-full h-full object-cover z-[-1] brightness-50"
      />
      <div className="w-full h-screen flex flex-col items-center justify-center">
        <div className="py-8">
          <img
            src={LogoSplashDark}
            alt="Img not found"
            className="h-96 animate-pulse duration-700"
          />
        </div>
      </div>
    </div>
  );
}
